import { categories } from "@/mocks/categories";

interface ScoopToolbarProps {
  activeCat: string;
  keyword: string;
  resultCount: number;
  onCatChange: (key: string) => void;
  onKeywordChange: (value: string) => void;
}

export default function ScoopToolbar({
  activeCat,
  keyword,
  resultCount,
  onCatChange,
  onKeywordChange,
}: ScoopToolbarProps) {
  const tabs = [{ key: "all", label: "全部" }, ...categories.map((c) => ({ key: c.key, label: c.label }))];

  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex flex-wrap gap-2">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              type="button"
              onClick={() => onCatChange(tab.key)}
              className={`whitespace-nowrap rounded-full border px-4 py-1.5 text-sm font-medium transition-colors ${
                activeCat === tab.key
                  ? "border-primary-600 bg-primary-600 text-background-50"
                  : "border-foreground-950/15 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-700"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className="relative w-full lg:w-72">
          <span className="pointer-events-none absolute left-3 top-1/2 flex h-5 w-5 -translate-y-1/2 items-center justify-center text-foreground-400">
            <i className="ri-search-line text-base" aria-hidden="true"></i>
          </span>
          <input
            type="search"
            value={keyword}
            onChange={(e) => onKeywordChange(e.target.value)}
            placeholder="搜索爆料标题或关键词"
            aria-label="搜索爆料"
            className="w-full rounded-md border border-foreground-950/15 bg-background-50 py-2.5 pl-10 pr-4 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400"
          />
        </div>
      </div>

      <p className="text-xs text-foreground-500">
        共找到 <span className="font-medium text-foreground-800">{resultCount}</span> 条符合条件的爆料线索
      </p>
    </div>
  );
}